import Vue from 'vue';
import Vuex from 'vuex';
import App from './App.vue';
import router from './router';
import vuetify from './plugins/vuetify';
import '@aws-amplify/ui-vue';
import { Auth, Hub } from 'aws-amplify';

import store from './store';

Vue.use(Vuex);
Vue.config.productionTip = false;

const dayjs = require( 'dayjs' );

const globalState = {
    debug : true,

    root : null,

    isSignedIn : false,
    account : null,
    userRole : { isSuperUser : false, isAdminUser : false, isCheckoutUser : false },
    currentDate : dayjs(),

    // Map of account login ID to devices array returned by tools.js:pingAccount()
    accountDevicesCache : {},

    setDate( date ) {
        this.currentDate = date;
        Hub.dispatch( 'monitor', { event : 'ev:changeDate', data : date } );
    },

    changeDate( numberOfDays ) {
        this.setDate( this.currentDate.add( numberOfDays, 'day' ) );
    },

    localDate() {
        return this.currentDate.format( 'YYYY-MM-DD' );
    },

    setIsSignedIn( isSignedIn ) {
        // if ( this.debug ) console.log( `G: Setting isSignedIn to `, isSignedIn );

        this.isSignedIn = isSignedIn;
        Hub.dispatch( 'monitor', { event : 'ev:isSignedIn', data : isSignedIn } );
    },

    setAccount( account ) {
        // if ( this.debug ) console.log( `G: Setting account to ${account.description} (${account.loginId})` );

        this.account = account;

        Hub.dispatch( 'monitor', { event : 'ev:setAccount', data: account } );
    },

    setUserRole( userRole ) {
        if ( this.debug ) console.log( `G: User rule set to ${userRole}` );

        this.userRole = userRole;
        Hub.dispatch( 'monitor', { event : 'ev:userRole', data : userRole } );
    },
};

Auth.currentAuthenticatedUser()
    .then( () => globalState.setIsSignedIn( true ) )
    .catch( () => globalState.setIsSignedIn( false ) );


Hub.listen( 'auth', data => {
    if ( data.payload.event === 'signIn' ) {
        globalState.setIsSignedIn( true );
    }

    if ( data.payload.event === 'signOut' ) {
        globalState.setIsSignedIn( false );
    }
} );

globalState.root = new Vue({
    router,
    store,
    vuetify,
    data : {
        globalState,
    },
    render: h => h(App)
}).$mount('#app');
